import Vue from 'vue';
import App from './App.vue';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Router from 'vue-router';
import LoadProfileDetails from './components/LoadProfileDetails.vue';
import Board from './components/Board.vue';
import BoardList from './components/BoardList.vue';
import Auth from './components/Auth.vue';
import DocumentList from './components/DocumentList.vue';
import DocumentPage from './components/DocumentPage.vue';
import ProcessRunner from './components/ProcessRunner.vue';
import redirect from './components/redirect.vue';
import Impressum from './components/Impressum.vue';
import Privacy from './components/Privacy.vue';
import Home from './components/Home.vue';
import AccessDenied from './components/AccessDenied.vue';
import PageNotFound from './components/PageNotFound.vue';

//amplify
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import awsconfig from './aws-exports-custom';
import { AmplifyEventBus } from 'aws-amplify-vue';
import store from './store/store';

// Define userpool based on URL
let cognitoClient = awsconfig.codelos;
if (location.href.includes('.team-energie.')) {
  cognitoClient = awsconfig.teamenergie;
}

Amplify.configure(cognitoClient);
Vue.use(AmplifyPlugin, AmplifyModules);

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

//vue-recource for restful apis
import VueResource from 'vue-resource';
Vue.use(VueResource);

import AsyncComputed from 'vue-async-computed';
Vue.use(AsyncComputed);

import vueKanban from 'vue-kanban';
import { isUserNotLoggedIn } from './router/guards/auth.guard';
Vue.use(vueKanban);

Vue.use(Router);
Vue.config.productionTip = false;

let user;
let mounted = false;

AmplifyEventBus.$on('authState', async (state) => {
  if (state === 'signedOut') {
    // Reset all values
    mounted = false;
    store.commit('clearStore');
    router.push({ path: '/auth' });
  } else if (state === 'signedIn') {
    user = await getUser();
    let path = decodeURIComponent(
      router.history.current.fullPath
        .replace('/auth?redirect=', '')
        .replace('/auth', '/')
    );
    router.push({ path: path });
  }
});

async function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
    .then(async (data) => {
      if (data && data.signInUserSession) {
        store.commit('setUser', data);

        // Set isAdmin
        const email = data.attributes.email;
        const adminMails = ['codelos.io', 'esparkinfo.com'];
        const isJanik = email == 'janik@codelos.io';
        if (adminMails.includes(email.split('@')[1]) && !isJanik) {
          store.commit('setIsAdmin', true);
        } else {
          store.commit('setIsAdmin', false);
        }

        if (!mounted) {
          // Set loading
          store.commit('setLoading', true);

          // Get all resources
          store.dispatch('getFlows');
          store.dispatch('fetchFlowAccessLevel');
          store.dispatch('getUserSettings');
          await store.dispatch('getUserSettingsDB');
          mounted = true;

          // Remov loading
          store.commit('setLoading', false);
        }
        return data;
      }
    })
    .catch(() => {
      store.commit('setUser', null);
      return null;
    });
}

// Catch errors from router
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/load-profile-details',
    name: 'loadProfileDetails',
    component: LoadProfileDetails,
    meta: { requiresAuth: true },
  },
  {
    path: '/board',
    name: 'board',
    component: Board,
    meta: { requiresAuth: true },
  },
  {
    path: '/board-list',
    name: 'boardList',
    component: BoardList,
    meta: { requiresAuth: true },
  },
  {
    path: '/process-runner/:id',
    name: 'process-runner',
    component: ProcessRunner,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
    props: true,
    beforeEnter: isUserNotLoggedIn,
  },
  {
    path: '/document-list',
    name: 'document-list',
    component: DocumentList,
    meta: { requiresAuth: true },
  },
  {
    path: '/document-page',
    name: 'document-page',
    component: DocumentPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: Impressum,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    props: (route) => ({
      section: route.query.section,
      database: route.query.database,
      processID: route.query.process,
      itemID: route.query.item,
    }),
    meta: { requiresAuth: true },
  },
  {
    path: '/redirect/:id',
    name: 'redirect',
    component: redirect,
    props: true,
  },
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: AccessDenied,
  },
  {
    path: '/page-not-found',
    name: 'pageNotFound',
    component: PageNotFound,
  },
];

//components.Authenticator
export const router = new Router({
  routes,
});

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    user = await getUser();
    if (!user) {
      return next({
        path: '/auth',
        query: {
          redirect: to.fullPath,
        },
      });
    }
    return next();
  }
  return next();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
